import { render, staticRenderFns } from "./NFC.vue?vue&type=template&id=0ce98bb3&scoped=true"
import script from "./NFC.vue?vue&type=script&lang=js"
export * from "./NFC.vue?vue&type=script&lang=js"
import style0 from "./NFC.vue?vue&type=style&index=0&id=0ce98bb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce98bb3",
  null
  
)

export default component.exports